import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import { ref, onMounted, reactive, watch, nextTick } from "vue";
import { useRouter, useRoute } from "vue-router";
import BannerSwiper from "@/components/BannerSwiper/index.vue";
import Domain from "@/pages/pipeline/components/domain.vue";
import ArticleList from "@/pages/pipeline/components/articleList.vue";
export default {
  components: {
    BannerSwiper: BannerSwiper,
    Domain: Domain,
    ArticleList: ArticleList
  },
  name: "pipeline",
  setup: function setup() {
    var bannerList = reactive([{
      id: 0,
      // new_pipeline_banner_03
      // imageUrl: "https://cdn.tenacia.com/base/tenacia-img/new_pipeline_banner_03.png",
      imageUrl: require('./images/new_pipeline_banner_03.jpg')
    }]);
    var router = useRouter();
    var route = useRoute();
    onMounted(function () {
      var hash = window.location.hash; // console.log('hash:', hash)

      if (hash.indexOf('#') != -1) {
        nextTick(function () {
          var id = hash.split('#')[1];
          id = decodeURIComponent(id);
          var el = document.getElementById(id); // console.log('滚动到：', id, el)

          if (el) {
            // 平滑滚动
            setTimeout(function () {
              el.scrollIntoView({
                behavior: 'smooth'
              });
            }, 0);
          }
        });
      }
    }); // 监听路由变化，滚动到对应位置

    watch(function () {
      return route.hash;
    }, function (newVal, oldVal) {
      var hash = window.location.hash; // console.log('hash:', hash)
      // hash 删除第一个字符(当前项目是hsah模式)
      // hash = hash.slice(1);
    }); // console.log("bannerList=", bannerList.value)

    return {
      bannerList: bannerList
    };
  }
};